export default "__VITE_ASSET__DNUQH4PF__"